import { render, staticRenderFns } from "./MatchContainerWrapped.vue?vue&type=template&id=0df748ef&scoped=true"
import script from "./MatchContainerWrapped.vue?vue&type=script&lang=js"
export * from "./MatchContainerWrapped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df748ef",
  null
  
)

export default component.exports